import { initChart, getCommonOptionDonut } from '../common';

export function echartIntensidadDiarialCiclista(vis, datos) {
  const data = datos.resultset.map(([name, value]) => ({ name, value }));
  const colors = ['#4EA8DE', '#FFBF69', '#83C5BE', '#E56B6F', '#CDB4DB'];
  const options = getCommonOptionDonut(
    data,
    'Major intensitat diària',
    undefined,
    colors,
  );

  initChart('chartIntensidadDiarialCiclista', options);
}
